import { useState, useCallback, useContext } from "react";
import { formatDate, basePath } from "../Constants/constant";
import axios from "axios";
import { AppContext } from '../ContextApi/ContextApi';
import BasicButton from "../Usables/Buttons";
import InputField from "../Usables/InputField";
import { FiUsers, FiUserCheck } from "react-icons/fi";
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const RecruiterSummaryReport = ({allUsers, usersOption}) => {
    const { apiHeaderJSON } = useContext(AppContext);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [showAllUsers, setShowAllUsers] = useState(false);
    const [filterData, setFilterData] = useState({
        fromDate: "",
        toDate: "",
        recruiterIds: [],
    });

    const displayedUsers = showAllUsers ? allUsers : usersOption;

    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFilterData({ ...filterData, [name]: value, });   
    },[filterData]);
    
    const handleClear = useCallback(()=> {
        // setLoadingFilter("2");
        setFilterData({
            fromDate: "",
            toDate: "",
            recruiterIds:[]   
        });
        
    }, []);

    const handleExport = async () => {
        try {
            setLoadingFilter('1');
            Swal.fire({
                title: 'Please wait...',
                html: 'Your file is being prepared for download.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
                const response = await axios.get(`${basePath}/Reports/GetPositionWiseTeamReport`, {
                    params: {
                        filter: filterData,
                    },
                    headers: apiHeaderJSON,
                    responseType: 'blob'  
                });
                // const response = await axios.get(`${basePath}/Reports/RecruiterSummaryReport`, {
                //     params: {
                //         filter: filterData,
                //     },
                //     headers: apiHeaderJSON,
                //     responseType: 'blob'  
                // });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Team Summary Report from ${formatDate(filterData?.fromDate)} to ${formatDate(filterData?.toDate)}.xlsx`);
            document.body.appendChild(link);
            link.click();
            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            Swal.close();
            toast.success("Excel Exported Successfully!");
            setLoadingFilter(false);
            setFilterData({
                fromDate: "",
                toDate: "",
                recruiterIds:[]   
            });
        } catch (error) {
            let errorMsg = "There was a problem with the download";
            if (error.response && error.response.data) {
                const blob = error.response.data;
                try {
                    // Read the blob as text (usually contains JSON string)
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const json = JSON.parse(reader.result);
                            errorMsg = json?.error || json?.message || errorMsg;
                        } catch (e) {
                            console.warn("Could not parse error response:", e);
                            errorMsg = "Something went wrong while processing.";
                        }
                        toast.error(errorMsg);
                        Swal.close();
                        setLoadingFilter(false);
                    };
                    reader.readAsText(blob);
                } catch (e) {
                    toast.error("Unable to read error response.");
                    Swal.close();
                    setLoadingFilter(false);
                }

            } else {
                // Network error or no response
                toast.error(error.message || errorMsg);
                Swal.close();
                setLoadingFilter(false);
            }
            Swal.close();
            
        }
    };

    return(
        <div className='grayBlurShadow bg-white p-6 mt-6 rounded-2xl'>
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-900">📊 Team Summary Reports</h1>
                <p className="text-sm text-gray-500 mt-1">Filter by date range and recruiter(s) to generate Summary reports.</p>
            </div>
            {/* filters */}
            <div className=' grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 mt-3'>
                    <InputField  id="fromDate" name="fromDate" type="date" label="From:"
                        disabled={loadingFilter === '1'}
                        value={filterData?.fromDate}
                        onChange={handleChangeFilter}
                    />
                    <InputField  id="toDate" name="toDate" type="date" label="To:"
                        disabled={loadingFilter === '1'}
                        value={filterData?.toDate}
                        onChange={handleChangeFilter}
                    />
                    <div className="flex gap-3 col-span-1">
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Export Report</label>
                        <BasicButton onClick={() => handleExport()}  buttonName='Export Report' className='darkPurple text-nowrap' shadow={true}
                        disabled={ loadingFilter || (!filterData?.fromDate || !filterData?.toDate || !filterData?.recruiterIds.length)}
                        loading={loadingFilter === "1"} 
                        loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                        <BasicButton  onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                        disabled={ loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.recruiterIds.length)}
                        loading={loadingFilter === "2"}
                        loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                    </div>
                    
                </div>
                        
            </div>
            {/* user list */}
           <div className="flex justify-between items-center mt-6 mb-3">
                <h2 className="text-lg font-semibold text-gray-800">
                    {showAllUsers ? 'All Recruiter' : 'Active Recruiter'} {filterData?.recruiterIds?.length ? `(${filterData?.recruiterIds?.length})`:`(0)` }
                </h2>
                <button
                    onClick={() => setShowAllUsers(prev => !prev)}
                    className="inline-flex items-center gap-2 text-sm text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 px-3 py-1.5 rounded-md shadow-sm transition duration-200"
                    >
                    {showAllUsers ? <FiUserCheck size={16} /> : <FiUsers size={16} />}
                </button>
            </div>
           <div className=" grayBlurShadow bg-white p-6 rounded-lg max-h-[200px] overflow-auto">
                <div className="flex items-center gap-2 mb-2">
                    <input
                        type="checkbox"
                        checked={
                        displayedUsers.length > 0 &&
                        displayedUsers.every(user => filterData.recruiterIds.includes(user.value))
                        }
                        onChange={(e) => {
                        if (e.target.checked) {
                            const allIds = displayedUsers.map(user => user.value);
                            setFilterData(prev => ({ ...prev, recruiterIds: allIds }));
                        } else {
                            setFilterData(prev => ({ ...prev, recruiterIds: [] }));
                        }
                        }}
                    />
                    <label className="text-sm font-medium text-gray-700">Select All</label>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {displayedUsers.map((val, idx) => {
                    const isSelected = filterData.recruiterIds.includes(val?.value);

                    return (
                        <div
                        key={idx}
                        className={`p-3 rounded-md text-sm font-medium shadow-sm cursor-pointer transition
                            ${isSelected ? 'text-green-500 greenBox' : 'bg-gray-100 text-gray-800'}
                        `}
                        onClick={() => {
                            setFilterData(prev => {
                            const updatedIds = isSelected
                                ? prev.recruiterIds.filter(id => id !== val?.value)  
                                : [...prev.recruiterIds, val?.value]; 

                            return {
                                ...prev,
                                recruiterIds: updatedIds
                            };
                            });
                        }}
                        >
                        {val?.label}
                        </div>
                    );
                    })}
                </div>
           </div>

        </div>
    )
}

export default RecruiterSummaryReport;